module.exports = __webpack_public_path__ + "img/pdf.2af27283.png";